
import { supabase } from "@/lib/supabase";
import { RefundFormValues } from "@/hooks/use-refund-form";
import { getDefaultCurrencyForCountry } from "@/utils/currency-data";

// Save request to the database for authenticated users
export const saveRequestToDatabase = async (
  userId: string,
  values: RefundFormValues, 
  userRegion: string | null,
  messageFormat: "email" | "chat" = "email"
): Promise<{ id: string; [key: string]: any } | null> => {
  // Determine currency with better fallback handling
  const currency = values.currency || getDefaultCurrencyForCountry(userRegion);
  console.log(`Using currency for database save: ${currency} (from form: ${values.currency}, region: ${userRegion})`);
  
  const { data, error } = await supabase
    .from("refund_requests")
    .insert({
      user_id: userId,
      merchant: values.merchant,
      product: values.merchant, // Use merchant name as product
      amount: values.amount ? parseFloat(values.amount) : 0,
      currency: currency,
      issue: values.issue,
      order_number: values.orderNumber,
      purchase_date: null,
      status: "pending",
      region: userRegion,
      message_format: messageFormat,
    })
    .select();

  if (error) {
    console.error("Error saving refund request to database:", error);
    throw error;
  }
  
  await supabase.from("messages").insert({
    refund_request_id: data[0].id,
    sender_type: "user",
    content: values.issue,
  });
  
  console.log("Refund request saved successfully with ID:", data[0].id);
  return data[0];
};

// Create a demo request object for non-authenticated users
export const createDemoRequest = (
  values: RefundFormValues, 
  userRegion: string | null,
  messageFormat: "email" | "chat" = "email"
): { id: string; [key: string]: any } => {
  const demoId = `demo-${Date.now()}`;
  // Determine currency with better fallback handling
  const currency = values.currency || getDefaultCurrencyForCountry(userRegion);
  console.log(`Using currency for demo request: ${currency} (from form: ${values.currency}, region: ${userRegion})`);
  
  return {
    id: demoId,
    merchant: values.merchant,
    product: values.merchant,
    amount: values.amount ? parseFloat(values.amount) : 0,
    currency: currency,
    issue: values.issue,
    order_number: values.orderNumber,
    status: "pending",
    region: userRegion,
    is_demo: true,
    message_format: messageFormat
  };
};
